export const VerificationType = {
  CORRECT: "correct",
  QUESTION: "question",
  WRONG: "wrong",
};
